import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';

const Wrapper = styled.div`
  display: grid;
  position: relative;
`;

const DataItem = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  :hover {
    cursor: pointer;
    background-color: ${theme.colors.neutral.bg.regular};
  }
`;

const DataItemText = styled.p`
  margin-left: ${theme.spacing['spacing-3']};
  padding-left: ${theme.spacing['spacing-1']};
  margin-bottom: auto;
  margin-top: auto;
`;

const DataResult = styled.div`
  background: ${theme.colors.neutral.bg.weak};
  position: absolute;
  width: 100%;
  top: ${theme.spacing['spacing-11']};
  height: auto;
  max-height: 200px;
  border-radius: ${theme.borderRadius['border-radius-2']};
  border: solid 1px ${theme.colors.neutral.border.regular};
  overflow: hidden auto;
  z-index: 2;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
  }
  &::-webkit-scrollbar-thumb {
    background: ${theme.colors.neutral.bg.stronger};
  }
  &::-webkit-scrollbar-thumb:hover {
  }
`;

const InputWrapper = styled.div`
  position: relative;
  input {
    ${({ showDisplay }) => css`
      opacity: ${showDisplay ? '0' : '1'};
    `}
`;

const InputDisplay = styled.div`
  position: absolute;
  z-index: 1;
  ${({ hasLabel }) => css`
    padding-top: ${hasLabel
      ? theme.spacing['spacing-7']
      : theme.spacing['spacing-3']};
  `}
  padding-left: ${theme.spacing['spacing-8']};
  padding-right: ${theme.spacing['spacing-4']};
  margin-left: ${theme.spacing['spacing-1']};
  display: flex;
  justify-content: space-between;
  outline: none;
  width: 100%;
`;

export {
  DataItem,
  Wrapper,
  DataResult,
  DataItemText,
  InputWrapper,
  InputDisplay,
};
